import React from 'react';
import classNames from 'classnames';

class Button extends React.Component {
    preventDefault = (e) => {
        e.preventDefault();
    };

    render() {
        const {
            className,
            children,
            tagName,
            defaultStyles = false,
            done,
            active,
            ...rest
        } = this.props;
        const buttonClasses = classNames(
            className,
            this.props.active ? 'active' : '',
            this.props.disabled ? 'disabled' : '',
            this.props.done ? 'done' : '',
            { button: defaultStyles },
        );
        const TagName = tagName || 'div';

        return (
            <TagName className={buttonClasses} {...rest}>
                {children}
            </TagName>
        );
    }
}

export default Button;



// WEBPACK FOOTER //
// ./components/Button/Button.jsx